<template>
  <div class="search-table-page">
    <el-form
      inline
      size="small"
      label-width="70px"
      label-position="left"
      :model="searchData"
      class="boldform">
      <el-form-item :label="'关键字'">
        <el-input
          style="width:200px"
          v-model="searchData.keyword"
          placeholder="请输入关键字"
        />
      </el-form-item>
      <el-form-item label="商品ID">
        <el-input
          style="width:200px"
          v-model="searchData.supplierProductId"
          placeholder="输入商品id"
        />
        <el-button
          size="mini"
          type="primary"
          round
          icon="el-icon-search"
          style="margin-left: 20px;"
          @click="searchList">
          搜索
        </el-button>
      </el-form-item>
    </el-form>
    <!-- 数据展示表格 -->
    <div class="table-content">
      <el-table
        ref="multipleTable"
        v-loading="tableLoading"
        :data="tableData"
        style="width: 100%; height: 100%"
        element-loading-text="Loading"
        border
        :highlight-current-row="false"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          align="center"
          width="35"
        />
        <el-table-column
          :label="'商品名称'"
          prop="areaCodes"
          align="center"
          min-width="180"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.supplierProductId }}
            </div>
            <div>{{ scope.row.productName }}</div>
          </template>
        </el-table-column>
        <el-table-column
          :label="'地区'"
          align="center"
          min-width="100"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.areaName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="'结算价'"
          min-width="100"
          align="center"
        >
          <template slot-scope="scope">
            <p>￥{{ scope.row.priceBase }}</p>
          </template>
        </el-table-column>
        <el-table-column
          :label="'零售价'"
          min-width="100"
          align="center"
        >
          <template slot-scope="scope">
            <p>
              ￥{{ scope.row.priceSale }}
            </p>
          </template>
        </el-table-column>
        <el-table-column
          :label="'市场价'"
          min-width="100"
          align="center"
        >
          <template slot-scope="scope">
            <p>￥{{ scope.row.priceList }}</p>
          </template>
        </el-table-column>
        <el-table-column
          :label="'库存'"
          min-width="70"
          align="center"
        >
          <template slot-scope="scope">
            <p>
              {{ scope.row.stockNum }}
            </p>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          :label="'商品状态'"
          width="80"
        >
          <template slot-scope="scope">
            <div>
              {{ commonEnumFormat(productState, scope.row.state) }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="margin-top: 10px" />
    <!-- 分页内容 -->
    <div
      style="margin-top: 40px;"
      class="pagination-container pagination-right space-between"
      element-loading-spinner="el-icon-loading">
      <el-pagination
        size="mini"
        background
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="resultNum"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="pageSizeChange"
        @current-change="pageCurrentChange"
      />
      <div class="flex-align">
        <el-button size="mini" @click="$emit('change')">取消</el-button>
        <el-button size="mini" type="primary" @click="confirm">确认报名</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { getlistSaasProduct, enrol } from '@/api/exchange.ts'
export default {
  name: 'SelectProdcutList',
  data () {
    return {
      tableData: [],
      allTableData: [],
      tableLoading: false,
      loading: false,
      productAdd: false,
      searchData: {
        cityName: '',
        keyword: '',
        supplierProductId: '',
        viewId: '', // 商品ID
        isExpress: -99, // 是否配送
        searchTags: {
          isExpressName: '全部' // 配送名称
        }
      },
      currentPage: 1, // 当前页
      resultNum: 20, // 每页条数
      total: 0, // 总条数
      indexId: '',
      isExpressType: [
        { value: -99, label: '全部' },
        { value: 1, label: '需要配送' },
        { value: 0, label: '不需要配送' }
      ],
      productState: [
        { value: -99, label: '全部' },
        { value: -1, label: '删除' },
        { value: 0, label: '下架' },
        { value: 1, label: '上架' }
      ],
      // 商品状态
      multipleSelection: []
    }
  },
  created () {
    this.listProducts()
  },
  methods: {
    handleSelectionChange (val) {
      console.log(val, 123455)
      this.multipleSelection = val
    },
    commonEnumFormat (options, state) {
      if (options.length > 0 && typeof state !== 'undefined' && state !== null) {
        const item = options.filter(ele => ele.value === state)
        if (item !== null && typeof item !== 'undefined' && item.length > 0) {
          return item[0].label
        }
      }
      return ''
    },
    // 获取产品列表
    async listProducts () {
      const params = {
        page: this.currentPage,
        resultNum: this.resultNum,
        keyword: this.searchData.keyword,
        supplierProductId: this.searchData.supplierProductId
      }
      this.tableLoading = true
      try {
        const res = await getlistSaasProduct(params)
        if (res && res.results) {
          this.allTableData = res.results
          this.tableData = (res.results || []).filter(ele => ele.parentId === 0)
          this.total = res.sizeAll
        } else {
          this.tableData = null
          this.total = 0
        }
        this.tableLoading = false
      } catch (e) {
        this.tableLoading = false
        console.log(JSON.stringify(e) || '异常错误')
      }
    },
    async confirm () {
      if (this.multipleSelection.length === 0) {
        this.$message.error('请先选择商品')
        return
      }
      const res = await enrol(this.multipleSelection, this.$route.query.id)
      if (!res.success) {
        this.$message.error(res.msg)
        return
      }
      this.$message.success(res.msg)
      this.$emit('change')
    },
    // 搜索
    searchList () {
      this.currentPage = 0
      this.listProducts()
    },
    // 切换每页显示条数
    pageSizeChange (val) {
      this.resultNum = val
      this.listProducts()
    },
    // 切换当前页
    pageCurrentChange (val) {
      this.currentPage = val
      this.listProducts()
    }
  }
}
</script>
<style lang="less" scoped>
</style>
<style lang="less">
  .search-table-page {
    .table-content {
      max-height: 500px;
      overflow: auto;
      .el-table__expanded-cell[class*=cell] {
        padding-right: 0;
      }
    }
    .el-form-item label {
      word-break: break-all;
      white-space: normal;
      word-wrap: break-word;
    }
  }
</style>
